import styled from 'styled-components'

export const StyledDropdown = styled.div`
  display: inline-block;
  text-decoration: none;
  text-align: right;
  position: relative;
  padding: 10px 5px;
  margin-left: 10px;
  min-width: max-content;
  font-size: 11pt;

  :hover {
    cursor: pointer;
  }

  label {
    color: ${props => props.theme.fontColor};
    text-align: left;
    max-width: 250px;
  }

  .text-label {
    display: inline-flex;
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  label:hover {
    cursor: pointer;
  }

  .fa-angle-down {
    vertical-align: text-bottom;
    padding-left: 5px;
  }

  ul {
    visibility: hidden;
    display: none;
    opacity: 0;
    position: absolute;
    text-decoration: none;
    padding: 8px 0;
    margin-top: 0;
    background: white;
    list-style: none;
    text-decoration: none;
    background-clip: border-box;
    border: none;
    box-sizing: border-box;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -webkit-box-sizing: border-box;
    color: #3c4043;
    line-height: 1.43;
    letter-spacing: 0.3px;
    box-shadow: 0 2px 6px 2px rgb(60 64 67 / 15%), 0 1px 2px 0 rgb(60 64 67 / 30%);
    cursor: pointer;
    font: 400 14px 'Roboto', RobotoDraft, Helvetica, Arial, sans-serif;
    margin: 8px 0 0;
    outline: none;
    text-align: left;
    right: 0;
    width: 200px;
    z-index: 1;
  }

  .show {
    visibility: visible;
    opacity: 1;
    display: block;
  }

  .hidden {
    display: none;
    visibility: hidden;
    opacity: 0;
  }

  ul li {
    clear: both;
    width: 90%;
    margin: 4px 0;
    padding: 7px 10px;
    overflow-wrap: break-word;
  }

  ul li:hover {
    background-color: hsl(0, 0%, 90%);
  }

  @media only screen and (max-width: 600px) {
    z-index: unset;
    ul {
      z-index: 1;
    }
  }
`

export const StyledFilterDateRange = styled.div`
  display: inline-block;
  text-decoration: none;
  text-align: right;
  position: relative;
  padding: 10px 5px;
  margin-left: 10px;
  min-width: max-content;
  z-index: 1;
  font-size: 11pt;

  :hover {
    cursor: pointer;
  }

  label {
    color: ${props => props.theme.fontColor};
    text-align: left;
  }

  label:hover {
    cursor: pointer;
  }

  .fa-angle-down {
    vertical-align: text-bottom;
    padding-left: 5px;
  }
`

export const StyledSearch = styled.div`
  position: relative;
  max-width: 400px;
  min-width: 150px;
  .search-icon {
    color: ${props => props.theme.fontColor};
    position: absolute;
    padding: 10px 5px;
  }
  input {
    font-size: 14px;
    width: 250px;
    align-items: center;
    border-width: 0px;
    border-radius: 2px;
    cursor: default;
    display: flex;
    padding: 10px 10px;
    text-indent: 20px;
  }

  input:hover {
    cursor: pointer;
    padding-left: 12px;
    background-color: hsl(0, 0%, 95%);
    transition: all 0.3s ease-in-out;
  }

  @media only screen and (max-width: 600px) {
    input {
      font-size: 16px;
    }
    .search-icon {
      padding: 10px;
    }
  }
`

export const StyledFilterBar = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: ${({ noBorder }: { noBorder?: boolean }) => (noBorder ? 'auto' : 'auto auto 30px auto')};
  display: flex;
  padding-top: 10px;
  padding-bottom: ${({ noBorder }: { noBorder?: boolean }) => (noBorder ? '0' : '5px')};
  justify-content: space-between;
  align-items: center;
  border-bottom: ${({ noBorder }: { noBorder?: boolean }) => (noBorder ? 'none' : '1px solid #e3e3e3;')};

  @media only screen and (max-width: 600px) {
    flex-flow: column-reverse;
    background-color: lightgrey;
    padding: 10px;
  }
`

export const FilterLeftWrapper = styled.div`
  @media only screen and (max-width: 600px) {
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    justify-content: end;
    padding-right: 10px;
  }
`
